// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_formContainer__fegA7 {
  border-left-width: 2px;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: auto;
  display: flex;
  padding: 20px;
}

.styles_logo__uD3er {
  box-sizing: border-box;
  position: absolute;
}

.styles_inputContainer__jAOhz {
  margin-bottom: 20px;
  width: 100%;
}

.styles_inputContainerMobile__X9-6D {
  width: calc(100% - 100px);
}

.styles_inputContainerCode__CQL9\\+ {
  width: 80px;
}

.styles_extraWrapperStyle__v6xu6 {
  width: 50px !important;
}

.styles_formContainer__fegA7 > div {
  max-width: 400px;
}

.styles_extraMargin__T7YGQ {
  margin-top: 10px;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 20px;
}

.styles_wrapper__--AKt {
  width: 100%;
}

.styles_submitItem__MaFRT {
  margin: 0 5px !important;
  cursor: pointer;
  flex-direction: row-reverse;
  border-radius: 6px !important;
  background-color: inherit !important;
  font-size: 16px !important;
  line-height: 25px !important;
  height: auto !important;
}

.styles_kidzyButton__yNs09 {
  border: none;
  color: #713be1 !important;
  opacity: 0.8;
}

.styles_kidzyText__wcnaf {
  opacity: 0.8;
  font-size: 16px !important;
  line-height: 25px !important;
  color: #713be1 !important;
  height: auto;
  text-align: center;
  width: 100%;
}

.styles_submitItem__MaFRT span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
}

.styles_formTitle__ReCYT {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 1em;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_formButton__IXvwS {
  width: 100% !important;
}

.styles_formButton__IXvwS > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_bottomTexts__gzoPn {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 9px;
}

.styles_bottomTexts__gzoPn > p:nth-child(1) {
  margin: 5px;
}

.styles_forgetText__rkxHJ {
  padding-top: 4px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_formHeader__S4Vgc {
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 5px;
}

.styles_inputError__zjuXc {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_serverError__AHITc {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__AHITc span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_flexStyle__t-C3F {
  flex-direction: row;
  border-radius: 10px;
  height: auto;
  width: auto !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.styles_extraMargin__T7YGQ {
  margin-top: 10px;
}

.styles_inputStyle__YrCyC {
  width: 353px !important;
  height: 100%;
}

@media only screen and (max-width: 1024px) {
  .styles_flexStyle__t-C3F {
    flex-direction: column;
  }
  .styles_flexStyle__t-C3F > div:nth-child(2) {
    margin: 0 auto;
    margin-top: 20px;
  }
  .styles_formContainer__fegA7 {
    border-left-width: 0px;
  }
}
@media only screen and (max-width: 800px) {
  .styles_force_media__1LLO6 {
    padding: 0 10px 0 10px !important;
  }
  .styles_flexStyle__t-C3F {
    flex-direction: column-reverse;
    overflow: auto;
    padding-bottom: 20px;
    scrollbar-color: #e3e3e3 transparent;
    scrollbar-width: 8px;
  }
  .styles_flexStyle__t-C3F::-webkit-scrollbar {
    background: transparent;
    width: 8px;
  }
  .styles_flexStyle__t-C3F::-webkit-scrollbar-thumb {
    background-color: #e3e3e3;
    border-radius: 100px;
    height: 8px;
  }
  .styles_flexStyle__t-C3F > div:nth-child(2) {
    margin: 0;
    margin-top: 20px;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .styles_inputStyle__YrCyC {
    width: 100% !important;
  }
  .styles_bottomText__HxrRq {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    margin: 0;
    padding: 0;
    margin-left: 8px;
  }
  .styles_mobileSignup__hZNwD {
    justify-content: center;
    flex-direction: row;
    align-items: center;
    width: auto;
    display: flex;
    margin-top: 14px;
    margin-bottom: 14px;
  }
  .styles_mobileSignup__hZNwD > span {
    width: auto !important;
  }
  .styles_submitItem__MaFRT {
    border: none;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 19px !important;
    width: 100%;
    border: unset !important;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/Login/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EAGA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EAEA,aAAA;AAFF;;AAMA;EACE,sBAAA;EACA,kBAAA;AAHF;;AAOA;EACE,mBAAA;EACA,WAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAQA;EACE,sBAAA;AALF;;AAQA;EAEE,gBAAA;AANF;;AASA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA;EACE,wBAAA;EACA,eAAA;EACA,2BAAA;EAEA,6BAAA;EACA,oCAAA;EAEA,0BAAA;EACA,4BAAA;EAEA,uBAAA;AATF;;AAYA;EACE,YAAA;EAEA,yBAAA;EACA,YAAA;AAVF;;AAaA;EAEE,YAAA;EACA,0BAAA;EACA,4BAAA;EAEA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAZF;;AAeA;EAEE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EAEA,mBAAA;EAIA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,sBAAA;AAjBF;;AAoBA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAjBF;;AAoBA;EAEE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,WAAA;AAlBF;;AAqBA;EAGE,gBAAA;EAGA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtBF;;AA0BA;EAEE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBF;;AA2BA;EACE,mBAAA;EAGA,mBAAA;EAGA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AA5BF;;AA+BA;EACE,gBAAA;AA5BF;;AA+BA;EACE,uBAAA;EAEA,YAAA;AA7BF;;AAgCA;EACE;IACE,sBAAA;EA7BF;EAgCA;IACE,cAAA;IACA,gBAAA;EA9BF;EAiCA;IACE,sBAAA;EA/BF;AACF;AAmCA;EACE;IACE,iCAAA;EAjCF;EAoCA;IACE,8BAAA;IACA,cAAA;IAEA,oBAAA;IAGA,oCAAA;IACA,oBAAA;EArCF;EAwCA;IAEE,uBAAA;IACA,UAAA;EAvCF;EA0CA;IACE,yBAAA;IACA,oBAAA;IACA,WAAA;EAxCF;EA2CA;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;IACA,qBAAA;EAzCF;EA4CA;IACE,sBAAA;EA1CF;EA6CA;IACE,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,SAAA;IACA,UAAA;IAGA,gBAAA;EA7CF;EAsDA;IACE,uBAAA;IACA,mBAAA;IACA,mBAAA;IACA,WAAA;IACA,aAAA;IACA,gBAAA;IACA,mBAAA;EApDF;EAuDA;IACE,sBAAA;EArDF;EAwDA;IACE,YAAA;IACA,6BAAA;IACA,2BAAA;IACA,0BAAA;IACA,4BAAA;IACA,WAAA;IACA,wBAAA;EAtDF;AACF","sourcesContent":[".formContainer {\n  border-left-width: 2px;\n  // padding-left: 1.5rem;\n  // padding-right: 1.5rem;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: auto;\n  display: flex;\n\n  padding: 20px;\n\n}\n\n.logo {\n  box-sizing: border-box;\n  position: absolute;\n\n}\n\n.inputContainer {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.inputContainerMobile {\n  width: calc(100% - 100px);\n}\n\n.inputContainerCode {\n  width: 80px;\n  // margin: 0 10px;\n}\n\n.extraWrapperStyle {\n  width: 50px !important;\n}\n\n.formContainer>div {\n  // min-width:30vw;\n  max-width: 400px;\n}\n\n.extraMargin {\n  margin-top: 10px;\n  margin-bottom: 0;\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.wrapper {\n  width: 100%;\n}\n\n.submitItem {\n  margin: 0 5px !important;\n  cursor: pointer;\n  flex-direction: row-reverse;\n  // border: 1px solid #d8000d !important;\n  border-radius: 6px !important;\n  background-color: inherit !important;\n\n  font-size: 16px !important;\n  line-height: 25px !important;\n  // color: #e30813 !important;\n  height: auto !important;\n}\n\n.kidzyButton {\n  border: none;\n  // color: rgb(41 15 188) !important;\n  color: #713be1 !important;\n  opacity: 0.8;\n}\n\n.kidzyText {\n  // color: rgb(41 15 188) !important;\n  opacity: 0.8;\n  font-size: 16px !important;\n  line-height: 25px !important;\n  // color: #e30813 !important;\n  color: #713be1 !important;\n  height: auto;\n  text-align: center;\n  width: 100%;\n}\n\n.submitItem span {\n  // color: #e30813 !important;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n}\n\n.formTitle {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  // color: #707070;\n  padding-bottom: 1em;\n\n  // color: rgba(0, 0, 0, 0.50);\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.formButton {\n  width: 100% !important;\n}\n\n.formButton>button {\n  width: 100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.bottomTexts {\n  // color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-top: 9px;\n}\n\n.bottomTexts>p:nth-child(1) {\n  margin: 5px;\n}\n\n.forgetText {\n\n  // color: #d8000d;\n  padding-top: 4px;\n  // color: #000;\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  // margin-bottom: 1em;\n}\n\n.formHeader {\n\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 5px;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n\n.serverError {\n  background: #ff9315;\n  border-radius: 4px;\n  color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 0.5em;\n  margin-bottom: 1em;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.serverError span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0 2px;\n}\n\n.flexStyle {\n  flex-direction: row;\n  // margin-top:40px;\n\n  border-radius: 10px;\n  // border: 1px solid rgba(0, 0, 0, 0.50);\n  // background: #FFF;\n  height: auto;\n  width: auto !important;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.extraMargin {\n  margin-top: 10px;\n}\n\n.inputStyle {\n  width: 353px !important;\n  // height: 44px;\n  height: 100%;\n}\n\n@media only screen and (max-width: 1024px) {\n  .flexStyle {\n    flex-direction: column;\n  }\n\n  .flexStyle>div:nth-child(2) {\n    margin: 0 auto;\n    margin-top: 20px;\n  }\n\n  .formContainer {\n    border-left-width: 0px;\n  }\n}\n\n// @media only screen and (max-width: 576px) {\n@media only screen and (max-width: 800px) {\n  .force_media {\n    padding: 0 10px 0 10px !important;\n  }\n\n  .flexStyle {\n    flex-direction: column-reverse;\n    overflow: auto;\n    // height: calc( 100vh - 138px);\n    padding-bottom: 20px;\n\n\n    scrollbar-color: #e3e3e3 transparent;\n    scrollbar-width: 8px;\n  }\n\n  .flexStyle::-webkit-scrollbar {\n\n    background: transparent;\n    width: 8px;\n  }\n\n  .flexStyle::-webkit-scrollbar-thumb {\n    background-color: #e3e3e3;\n    border-radius: 100px;\n    height: 8px;\n  }\n\n  .flexStyle>div:nth-child(2) {\n    margin: 0;\n    margin-top: 20px;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .inputStyle {\n    width: 100% !important;\n  }\n\n  .bottomText {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 19px;\n    margin: 0;\n    padding: 0;\n\n    // color: #000000;\n    margin-left: 8px;\n  }\n\n  .formContainer {\n    // border-left-width: 0;\n    // padding-left: 0;\n    // padding-right: 0;\n  }\n\n  .mobileSignup {\n    justify-content: center;\n    flex-direction: row;\n    align-items: center;\n    width: auto;\n    display: flex;\n    margin-top: 14px;\n    margin-bottom: 14px;\n  }\n\n  .mobileSignup>span {\n    width: auto !important;\n  }\n\n  .submitItem {\n    border: none;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    font-size: 12px !important;\n    line-height: 19px !important;\n    width: 100%;\n    border: unset !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `styles_formContainer__fegA7`,
	"logo": `styles_logo__uD3er`,
	"inputContainer": `styles_inputContainer__jAOhz`,
	"inputContainerMobile": `styles_inputContainerMobile__X9-6D`,
	"inputContainerCode": `styles_inputContainerCode__CQL9+`,
	"extraWrapperStyle": `styles_extraWrapperStyle__v6xu6`,
	"extraMargin": `styles_extraMargin__T7YGQ`,
	"wrapper": `styles_wrapper__--AKt`,
	"submitItem": `styles_submitItem__MaFRT`,
	"kidzyButton": `styles_kidzyButton__yNs09`,
	"kidzyText": `styles_kidzyText__wcnaf`,
	"formTitle": `styles_formTitle__ReCYT`,
	"formButton": `styles_formButton__IXvwS`,
	"bottomTexts": `styles_bottomTexts__gzoPn`,
	"forgetText": `styles_forgetText__rkxHJ`,
	"formHeader": `styles_formHeader__S4Vgc`,
	"inputError": `styles_inputError__zjuXc`,
	"serverError": `styles_serverError__AHITc`,
	"flexStyle": `styles_flexStyle__t-C3F`,
	"inputStyle": `styles_inputStyle__YrCyC`,
	"force_media": `styles_force_media__1LLO6`,
	"bottomText": `styles_bottomText__HxrRq`,
	"mobileSignup": `styles_mobileSignup__hZNwD`
};
export default ___CSS_LOADER_EXPORT___;
